const SvgCheck2 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 7 5">
    <path fill="#373737" fillRule="evenodd" d="M6.24 0 2.693 3.498.76 1.598 0 2.346 2.692 5 7 .754z" clipRule="evenodd" />
  </svg>;
export default SvgCheck2;